module.exports = __webpack_public_path__ + "a041ceaf1cfc0f6ad5ee0a6b640b9932.svg";


//////////////////
// WEBPACK FOOTER
// ./images/space_facility.svg
// module id = ./images/space_facility.svg
// module chunks = 5